import { AnalyticCard } from "@vega-core/components/MetricCard/AnalyticCard";
import { Skeleton } from "@vega-core/components/shadcn/skeleton";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import {
  type ChartInsightTrackingMetric,
  isBarChartMetric,
} from "../../utils/metricGuards";
import {
  BarChartMetricCard,
  CHART_HEIGHT_CLASS_NAME,
} from "../BarChartMetrics/BarChartMetrics";
import { PieChartMetricCard } from "../PieChartMetrics/PieChartMetrics";

const LOADING_PLACEHOLDERS = Array.from({ length: 3 }, (_, index) => index);

type InsightsChartCardsProps = {
  chartMetrics: ChartInsightTrackingMetric[];
  pieCenterLabel: string;
  dataTestId: string;
  isLoading?: boolean;
};

// Renders bar and pie chart metrics mixed in API order within a single grid.
export const InsightsChartCards = ({
  chartMetrics,
  pieCenterLabel,
  dataTestId,
  isLoading,
}: InsightsChartCardsProps) => {
  if (!isLoading && chartMetrics.length === 0) {
    return null;
  }

  return (
    <div
      className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-6 sm:[&>*:only-child]:max-w-[480px]"
      data-testid={dataTestId}
    >
      {isLoading
        ? LOADING_PLACEHOLDERS.map((id) => (
            <AnalyticCard
              dataTestId={`chart-loading-${id}`}
              isLoading
              key={id}
              title=""
            >
              <Skeleton
                className={cnTwMerge("mt-4", CHART_HEIGHT_CLASS_NAME)}
              />
            </AnalyticCard>
          ))
        : chartMetrics.map((metric) =>
            isBarChartMetric(metric) ? (
              <BarChartMetricCard key={`bar-${metric.label}`} metric={metric} />
            ) : (
              <PieChartMetricCard
                centerLabel={pieCenterLabel}
                key={`pie-${metric.label}`}
                metric={metric}
              />
            ),
          )}
    </div>
  );
};
